/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { templateStrings } from "../../../../Constant";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { mobileSettlementDetailsAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { exportExcel, getListUtil } from "../../../../shared/utils";
import SettlementDetails from "../../../../shared/components/commonComponents/SettlementDetails";

class MobileSettlementDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.mobileSettlementGetList();
  }

  componentDidUpdate(prevProps) {
    const { cityFilter, operatorFilter, dateFilter } = this.props;
    if (
      (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.dateFilter !== dateFilter)
    ) {
      this.mobileSettlementGetList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.mobileSettlementGetList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.mobileSettlementGetList();
      }
    });
  };

  downloadExcel = async () => {
    const id = "exportResidualSettlementData";
    const addOnFilter = {
      date: {
        fromDate: new Date(
          get(this, "props.location.state.fromDate", null),
        ).getTime(),
        toDate: new Date(
          get(this, "props.location.state.toDate", null),
        ).getTime(),
      },
      cityId: get(this, "props.location.state.cityId", ""),
      agencyId: get(this, "props.location.state.agencyId", ""),
      operatorFilter: this.props.operatorFilter,
      distributionType: "mobileTicket",
    };
    await exportExcel({ id, addOnFilter });
  };

  mobileSettlementGetList = () => {
    if (
      get(this, "props.location.state.fromDate", null)
      && get(this, "props.location.state.toDate", null)
    ) {
      getListUtil({
        dispatchFn: this.props.fetchMobileSettlementDetails,
        props: this.props,
        state: this.state,
        extraParam: "header",
      });
    } else {
      const { history } = this.props;
      history.push("/report/mobile-ticket");
    }
  };

  render() {
    return (
      <SettlementDetails
        inputProps={this.props}
        state={this.state}
        templateString={templateStrings.reportMobileSettlementDetails}
        heading="Mobile Ticket Distribution"
        downloadExcel={this.downloadExcel}
        handleChange={this.handleChange}
        onSortToggle={this.onSortToggle}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Report
        && state.Report.mobileSettlementDetails
        && state.Report.mobileSettlementDetails.data)
      || [],
    totalItems:
      (state
        && state.Report
        && state.Report.mobileSettlementDetails
        && state.Report.mobileSettlementDetails.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchMobileSettlementDetails: (value, loaderScope) => {
    dispatch(mobileSettlementDetailsAction(value, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileSettlementDetails);
